import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import {
  IMealCreditFormFields,
  Meridian,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

const isSameTime = (
  startTime: string,
  startTimeMeridian: Meridian,
  endTime: string,
  endTimeMeridian: Meridian
): boolean => startTime === endTime && startTimeMeridian === endTimeMeridian;

export const useEndTimeInput = (): { validate: () => string | boolean } => {
  const { watch, trigger, control } = useFormContext<IMealCreditFormFields>();

  const {
    endTimeMeridian,
    startTime,
    startTimeMeridian,
    endTime,
    timeIntervalType,
  } = watch([
    'startTime',
    'startTimeMeridian',
    'endTimeMeridian',
    'endTime',
    'timeIntervalType',
  ]);

  useEffect(() => {
    const isEndTimeRegistered = Boolean(control?.fieldsRef?.current?.endTime);

    if (isEndTimeRegistered) {
      trigger('endTime');
    }
  }, [
    startTime,
    startTimeMeridian,
    endTimeMeridian,
    endTime,
    timeIntervalType,
    trigger,
    control,
  ]);

  return {
    validate: (): string | boolean => {
      if (timeIntervalType === TimeIntervalTypeValues.OVERNIGHT) {
        return true;
      }

      if (isSameTime(startTime, startTimeMeridian, endTime, endTimeMeridian)) {
        return 'Start and end times cannot be the same';
      }

      return true;
    },
  };
};
